import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import { infoSnack, successSnack, errorSnack } from "../snackbar/snackbarSlice";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchBrands = createAsyncThunk(
  "brands/fetchBrands",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/brands${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setBrandsAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching brands list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreBrands = createAsyncThunk(
  "brands/fetchMoreBrands",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/brands${args.query}&offset=${args.offset}`,
        config
      );
      // let catQuery = [];
      // if (args.query.includes("categories")) {
      //   let urlSearchParams = new URLSearchParams(args.query);
      //   let params = Object.fromEntries(urlSearchParams.entries());
      //   catQuery = params.categories;
      // }
      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setBrandsAmount(response.headers["x-total-count"]));
      // thunkAPI.dispatch(updateCategories(catQuery));
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching brands list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const filterBrands = createAsyncThunk(
  "brands/filterBrands",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/brands${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchBrandByID = createAsyncThunk(
  "brands/fetchBrandByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/brands/${args.id}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching brands data"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteBrand = createAsyncThunk(
  "brands/deleteBrand",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.delete(
        `${baseURL}/v1/admin/brands/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("Brand deleted successfully"));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting brand"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateBrand = createAsyncThunk(
  "brands/updateBrand",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.patch(
        `${baseURL}/v1/admin/brands/${args.id}`,
        args.brand,
        config
      );
      thunkAPI.dispatch(fetchBrands({ token: args.token, query: "" }));
      thunkAPI.dispatch(successSnack("Brand updated successfully"));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating brand"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createBrand = createAsyncThunk(
  "brands/createBrand",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.post(
        `${baseURL}/v1/admin/brands`,
        args.brand,
        config
      );

      thunkAPI.dispatch(fetchBrands({ token: args.token, query: "" }));
      thunkAPI.dispatch(successSnack("Brand created successfully"));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating brand"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "brands/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreBrands(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full brand list");
      });
  }
);

const brandsSlice = createSlice({
  name: "brands",
  initialState: {
    brand: {},
    brandsList: [],
    brandsFilter: [],
    loading: "idle",
    message: "",
    error: "",
    editing: false,
    brandsAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setBrandsAmount: (state, action) => {
      state.brandsAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBrands.pending, (state) => {
      state.brandsList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchBrands.fulfilled, (state, { payload }) => {
      state.brandsList = payload;
      state.brandsFilter = payload;
      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchBrands.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreBrands.fulfilled, (state, { payload }) => {
      state.error = "";
      state.brandsList = state.brandsList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreBrands.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.brandsList = state.brandsList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(filterBrands.pending, (state) => {
      state.brandsFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(filterBrands.fulfilled, (state, { payload }) => {
      state.brandsFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(filterBrands.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchBrandByID.pending, (state) => {
      state.brand = {};
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchBrandByID.fulfilled, (state, { payload }) => {
      state.brand = payload;
      state.loading = "loaded";
      state.editing = true;
    });
    builder.addCase(fetchBrandByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(deleteBrand.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(deleteBrand.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deleteBrand.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateBrand.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(updateBrand.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updateBrand.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createBrand.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createBrand.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createBrand.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

// Action creators are generated for each case reducer function
export const { setLastQuery, setBrandsAmount } = brandsSlice.actions;

export const selectBrands = createSelector(
  (state) => ({
    brands: state.brands,
    loading: state.brands.loading,
    error: state.brands.error,
    editing: state.brands.editing,
    brand: state.brands.brand,
    brandsList: state.brands.brandsList,
    brandsAmount: state.brands.brandsAmount,
    lastQuery: state.brands.lastQuery,
  }),
  (state) => state
);
export default brandsSlice.reducer;
